// extracted by mini-css-extract-plugin
export default {"wrap":"Links_wrap__ZLX9I","btn":"Links_btn__FhK5v"};